
import { API_ENDPOINTS } from './api-endpoints';
import { crudFactory } from './curd-factory';
import { HttpClientFront } from './http-client-front';

export const companyClientgetInfo = {
  ...crudFactory(
    API_ENDPOINTS.COMPANY+"/bysymbol"
  )
};

export const companyClientShareholder = {
  ...crudFactory(
    API_ENDPOINTS.COMPANY+"/get_company_sharepattern"
  )
};

export const companyClientIndiceByComp = {
  ...crudFactory(
    API_ENDPOINTS.COMPANY+"/get_indices_bycompId"
  )
};

export const companyClientPeerByComp = {
  ...crudFactory(
    API_ENDPOINTS.COMPANY+"/get_peer_bycompId"
  )
};

export const companyClientQtrresult = {
  ...crudFactory(API_ENDPOINTS.COMPANY+"/get_company_quarterlyresult"),
    get({ id, type , company_type }) {
      return HttpClientFront.get(`${API_ENDPOINTS.COMPANY}/get_company_quarterlyresult/${id}`, {
      type , 
      company_type
    });
  },
};


export const companyClientFinRatios = {
  ...crudFactory(API_ENDPOINTS.COMPANY+"/get_company_finratios"),
    get({ id, type , company_type }) {
      return HttpClientFront.get(`${API_ENDPOINTS.COMPANY}/get_company_finratios/${id}`, {
      type ,
      company_type
    });
  },
};


export const companyClientBalanceSheet = {
  ...crudFactory(API_ENDPOINTS.COMPANY+"/get_company_balancesheet"),
    get({ id, type , company_type}) {
      return HttpClientFront.get(`${API_ENDPOINTS.COMPANY}/get_company_balancesheet/${id}`, {
      type,
      company_type,
    });
  },
};


export const companyClientCashFlow = {
  ...crudFactory(API_ENDPOINTS.COMPANY+"/get_company_cashflow"),
    get({ id, type , company_type }) {
      return HttpClientFront.get(`${API_ENDPOINTS.COMPANY}/get_company_cashflow/${id}`, {
      type , 
      company_type
    });
  },
};



export const companyClientProfitNloss = {
  ...crudFactory(API_ENDPOINTS.COMPANY+"/get_company_profitNloss"),
    get({ id, type ,company_type }) {
      return HttpClientFront.get(`${API_ENDPOINTS.COMPANY}/get_company_profitNloss/${id}`, {
      type,
      company_type
    });
  },
};


export const companyClientChartData = {
  ...crudFactory(
    API_ENDPOINTS.COMPANY+"/get_company_chartdata"
  )
};


export const companyClientChartOtherData = {
  ...crudFactory(
    API_ENDPOINTS.COMPANY+"/get_company_chartother"
  )
};





export const companyClientSectorByComp = {
  ...crudFactory(
    API_ENDPOINTS.COMPANY+"/get_sector_bycompId"
  )
};

export const companyClientAnalysis = {
  ...crudFactory(
    API_ENDPOINTS.COMPANY+"/getanalysisdata"
  )
};


export const companyClientAdvdisadv = {
  ...crudFactory(
    API_ENDPOINTS.COMPANY+"/advdisadvantage"
  ),
  get:({ 
    id,
    ...params 
  }) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.COMPANY}`+"/advdisadvantage/"+id, {
      ...params,
    });
  },
};




export const companyClientDefaultratioData = {
  ...crudFactory(
    API_ENDPOINTS.COMPANY+"/get_company_default_ratios"
  )
};


export const compFollowClientSave = {
  ...crudFactory(
    API_ENDPOINTS.FOLLOW_STOCK
  )
};

export const demoPortfolioClientSave = {
  ...crudFactory(
    API_ENDPOINTS.SAVEDEMOPORTFOLIO
  )
};


export const getSmeDetails = {
  
  ...crudFactory(API_ENDPOINTS.SMEMARKET),
  get:({ 
    id,
    ...params 
  }) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.SMEMARKET}/`+id, {
      ...params,
      
    });
  },
  all:(params ) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.SMEMARKET}`, params);
  },
};



export const getPortfolioDetails = {
  
  ...crudFactory(API_ENDPOINTS.GETALLDEMOPORTFOLIO),
  get:({ 
    id,
    ...params 
  }) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.GETALLDEMOPORTFOLIO}/`+id, {
      ...params,
      
    });
  },
  all:(params ) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.GETALLDEMOPORTFOLIO}`, params);
  },
};


export const getSuperInvestorDetails = {
  
  ...crudFactory(API_ENDPOINTS.SUPERINVESTORS),
  get:({ 
    id,
    ...params 
  }) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.SUPERINVESTORS}/`+id, {
      ...params,
      
    });
  },
  all:(params ) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.SUPERINVESTORS}`, params);
  },
};


export const companyClientInvestorySh = {
  ...crudFactory(
    API_ENDPOINTS.COMPANY+"/get_superinvestor_sh"
  )
};


export const companyClientPortfolioSingle = {
  ...crudFactory(
    API_ENDPOINTS.GETDEMOPORTFOLIOSINGLE
  )
};



export const companyClientAllCompany = {
  ...crudFactory(
    API_ENDPOINTS.ALLCOMAPNIES
  )
};


